var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#8a3eb8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2146_2250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.68745 16C8.68744 15.7653 8.76397 15.5714 8.9171 15.4183C9.07092 15.2645 9.26521 15.1875 9.49994 15.1875L15.1874 15.1875L15.1874 9.50003C15.1874 9.26531 15.2644 9.07139 15.4182 8.91828C15.5713 8.76445 15.7652 8.68753 15.9999 8.68753C16.2347 8.68754 16.4289 8.76445 16.5828 8.91829C16.7359 9.07139 16.8124 9.26531 16.8124 9.50003L16.8124 15.1875L22.4999 15.1875C22.7347 15.1875 22.9286 15.2645 23.0817 15.4183C23.2355 15.5714 23.3125 15.7653 23.3125 16.0001C23.3125 16.2348 23.2355 16.429 23.0817 16.5829C22.9286 16.736 22.7347 16.8126 22.5 16.8126L16.8124 16.8125L16.8125 22.5001C16.8125 22.7348 16.7359 22.929 16.5828 23.0829C16.429 23.2359 16.2347 23.3125 16 23.3125C15.7653 23.3125 15.5713 23.2359 15.4182 23.0828C15.2644 22.929 15.1875 22.7347 15.1874 22.5L15.1874 16.8125L9.49995 16.8125C9.26523 16.8125 9.07091 16.736 8.91713 16.5828C8.76396 16.4291 8.68746 16.2347 8.68745 16Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2146_2250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(16 6.80762) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusToggle);
export default __webpack_public_path__ + "static/media/plusToggle.b18dfa5603a2fb6715ad3f5ed920c5ad.svg";
export { ForwardRef as ReactComponent };